import { PropsWithChildren, createContext, useContext, useMemo } from 'react';
import type { CSSProperties } from 'react';
import { orangeTheme } from '../THD/colors';

type DiagramTheme = {
   clusterOuter: string;
   clusterInner: string;
   hotspotInner: string;
   hotspotOuter: string;
};

// Blue theme values matching the previous Chakra brand colors
const blueTheme: DiagramTheme = {
   clusterOuter: '#4299e1', // brand.400
   clusterInner: '#bee3f8', // brand.100
   hotspotInner: '#4299e1', // brand.400
   hotspotOuter: '#bee3f8', // brand.100
};

const getTheme = (name: string): DiagramTheme => {
   switch (name) {
      case 'orange': {
         return orangeTheme;
      }
      case 'blue': {
         return blueTheme;
      }
      default: {
         return blueTheme;
      }
   }
};

export type RequiredThemeProps = {
   theme: 'blue' | 'orange';
};

const DiagramThemeContext = createContext<DiagramTheme>(blueTheme);

export function useDiagramTheme() {
   return useContext(DiagramThemeContext);
}

export function SchematicThemeProvider({
   theme: themeName,
   children,
}: PropsWithChildren<RequiredThemeProps>) {
   const diagramTheme = useMemo(() => getTheme(themeName), [themeName]);

   const cssVars = {
      '--diagram-cluster-outer': diagramTheme.clusterOuter,
      '--diagram-cluster-inner': diagramTheme.clusterInner,
      '--diagram-hotspot-inner': diagramTheme.hotspotInner,
      '--diagram-hotspot-outer': diagramTheme.hotspotOuter,
   } as CSSProperties;

   return (
      <DiagramThemeContext.Provider value={diagramTheme}>
         <div style={cssVars}>{children}</div>
      </DiagramThemeContext.Provider>
   );
}
